var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-edition-map-chart-node"},[_c('MoleculeEditionMapChartNodeHeader',{attrs:{"is-node-item":true,"element":_vm.element}}),_c('MoleculeContentNode'),(_vm.$store.getters.getSelectedMapNode.path === 0 &&
      _vm.$store.getters.getSelectedMapNode.tarea)?_c('MoleculeEditionMapChartNodeTask',{attrs:{"id":"nodeTask"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }